// Communications Hub — Sample / Demo Data

export const CURRENT_USER = {
  id: 'user-1',
  name: 'Alex Morgan',
  initials: 'AM',
  role: 'investor',
  color: '#3b4c4c',
};

export const PARTICIPANTS = [
  { id: 'user-1', name: 'Alex Morgan', initials: 'AM', role: 'investor', color: '#3b4c4c', online: true },
  { id: 'user-2', name: 'Sarah Chen', initials: 'SC', role: 'sponsor', color: '#0f5132', online: true },
  { id: 'user-3', name: 'James Whitfield', initials: 'JW', role: 'admin', color: '#5c2d91', online: false },
  { id: 'user-4', name: 'Priya Nair', initials: 'PN', role: 'investor', color: '#7c3d12', online: true },
  { id: 'user-5', name: 'Oliver Hartley', initials: 'OH', role: 'sponsor', color: '#1e4d6b', online: false },
  { id: 'user-6', name: 'Emma Davies', initials: 'ED', role: 'investor', color: '#4a1942', online: true },
  { id: 'user-7', name: 'Ravi Patel', initials: 'RP', role: 'investor', color: '#1a4731', online: false },
  { id: 'user-8', name: 'Claire Bouchard', initials: 'CB', role: 'sponsor', color: '#3d1a1a', online: true },
];

export const THREADS = [
  {
    id: 'thread-1',
    name: 'Solano Wind Farm — IC Discussion',
    type: 'group',
    dealLinked: 'Solano Wind Farm',
    dealId: 'deal-8',
    roleTarget: ['investment_team', 'ic_member', 'legal_comp_team', 'platform_admin'],
    participants: ['user-1', 'user-2', 'user-3', 'user-4', 'user-5'],
    lastMessage: 'The technical due diligence report has been updated with revised capacity figures.',
    lastMessageTime: '2025-12-18T14:32:00Z',
    unreadCount: 3,
    pinned: true,
    active: true,
  },
  {
    id: 'thread-2',
    name: 'Nordic Fibre Network Phase II — Diligence Q&A',
    type: 'group',
    dealLinked: 'Nordic Fibre Network Phase II',
    dealId: 'deal-5',
    roleTarget: ['investment_team', 'external_investor', 'platform_admin'],
    participantContextIds: ['ctx-investment-team', 'ctx-external-investor', 'ctx-platform-admin'],
    participants: ['user-1', 'user-2', 'user-6', 'user-7'],
    lastMessage: 'Can you clarify the grid connection timeline in section 4.2?',
    lastMessageTime: '2025-12-18T11:15:00Z',
    unreadCount: 1,
    pinned: false,
    active: false,
  },
  {
    id: 'thread-3',
    name: 'GlobalInfra Partners — Onboarding',
    type: 'direct',
    dealLinked: null,
    dealId: null,
    roleTarget: ['investment_team', 'legal_comp_team', 'external_investor', 'platform_admin'],
    participantContextIds: ['ctx-investment-team', 'ctx-legal-comp-team', 'ctx-external-investor', 'ctx-platform-admin'],
    participants: ['user-1', 'user-3'],
    lastMessage: 'Welcome to SeedDrive. Your KYC documents have been verified.',
    lastMessageTime: '2025-12-17T09:00:00Z',
    unreadCount: 0,
    pinned: false,
    active: false,
  },
  {
    id: 'thread-4',
    name: 'Elbe Biomass Plant SPV — Syndication',
    type: 'group',
    dealLinked: 'Elbe Biomass Plant',
    dealId: 'deal-3',
    roleTarget: ['investment_team', 'finance_team', 'legal_comp_team', 'platform_admin'],
    participants: ['user-1', 'user-2', 'user-4', 'user-8'],
    lastMessage: 'The SPV structure has been finalised. Please review the cap table.',
    lastMessageTime: '2025-12-17T16:45:00Z',
    unreadCount: 2,
    pinned: false,
    active: false,
  },
  {
    id: 'thread-5',
    name: 'Avon Water Treatment SPV — Capital Call Notice',
    type: 'broadcast_reply',
    dealLinked: 'Avon Water Treatment Works',
    dealId: 'deal-6',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    participants: ['user-1', 'user-3'],
    lastMessage: 'Capital call of £2.1m due by 15 January 2026. Please confirm receipt.',
    lastMessageTime: '2025-12-16T10:00:00Z',
    unreadCount: 0,
    pinned: false,
    active: false,
  },
  {
    id: 'thread-6',
    name: 'Lisbon Metro Extension — Risk Flag Discussion',
    type: 'group',
    dealLinked: 'Lisbon Metro Extension',
    dealId: 'deal-4',
    roleTarget: ['investment_team', 'ic_member', 'legal_comp_team', 'platform_admin'],
    participants: ['user-1', 'user-2', 'user-5', 'user-6'],
    lastMessage: 'The planning permission delay has been escalated to the IC.',
    lastMessageTime: '2025-12-15T14:20:00Z',
    unreadCount: 1,
    pinned: false,
    active: false,
  },
  {
    id: 'thread-7',
    name: 'Tyne Bridge Toll Road — ESG Review',
    type: 'group',
    dealLinked: 'Tyne Bridge Toll Road',
    dealId: 'deal-7',
    roleTarget: ['investment_team', 'asset_mgmt_team', 'ic_member', 'platform_admin'],
    participants: ['user-1', 'user-2', 'user-7'],
    lastMessage: 'ESG score updated to 61/100 following the site audit.',
    lastMessageTime: '2025-12-14T11:30:00Z',
    unreadCount: 0,
    pinned: false,
    active: false,
  },
  {
    id: 'thread-8',
    name: 'SeedDrive Team — Platform Update',
    type: 'internal',
    dealLinked: null,
    dealId: null,
    roleTarget: ['investment_team', 'ic_member', 'asset_mgmt_team', 'finance_team', 'legal_comp_team', 'platform_admin'],
    participants: ['user-1', 'user-3'],
    lastMessage: 'Version 2.4.0 has been deployed with new reporting features.',
    lastMessageTime: '2025-12-13T09:00:00Z',
    unreadCount: 0,
    pinned: false,
    active: false,
  },
];

export const ANNOUNCEMENTS = [
  {
    id: 'ann-1',
    title: 'Q3 2025 Capital Call Schedule Released',
    priority: 'HIGH',
    roleTarget: ['investment_team', 'finance_team', 'asset_mgmt_team', 'platform_admin'],
    from: 'James Whitfield (Admin)',
    date: '2025-12-18T08:00:00Z',
    body: 'The Q3 2025 capital call schedule has been released. Investors are required to fund their committed capital by the dates specified in the attached schedule. Please review the document and acknowledge receipt by 22 December 2025. For any queries, please contact the fund administration team directly via this thread.',
    attachments: [{ name: 'Q3-2025-Capital-Call-Schedule.pdf', size: '245 KB', type: 'pdf' }],
    unread: true,
    replies: 2,
    acknowledged: false,
  },
  {
    id: 'ann-2',
    title: 'Platform Maintenance: 22 Dec 2025 02:00–04:00 GMT',
    priority: 'MEDIUM',
    roleTarget: ['investment_team', 'ic_member', 'asset_mgmt_team', 'finance_team', 'legal_comp_team', 'platform_admin'],
    from: 'James Whitfield (Admin)',
    date: '2025-12-17T14:00:00Z',
    body: 'Scheduled platform maintenance will take place on 22 December 2025 between 02:00 and 04:00 GMT. During this window, the platform will be unavailable. All pending transactions and document uploads should be completed before this window. We apologise for any inconvenience.',
    attachments: [],
    unread: false,
    replies: 0,
    acknowledged: true,
  },
  {
    id: 'ann-3',
    title: 'New ESG Reporting Framework — Updated Guidelines Available',
    priority: 'LOW',
    roleTarget: ['investment_team', 'asset_mgmt_team', 'finance_team', 'platform_admin'],
    from: 'James Whitfield (Admin)',
    date: '2025-12-10T10:00:00Z',
    body: 'Updated ESG reporting guidelines have been published in line with the new SFDR Article 9 requirements. All portfolio companies are required to submit updated ESG data using the new framework by Q1 2026. The full guidelines document is available in the Data Room under ESG & Compliance.',
    attachments: [{ name: 'ESG-Reporting-Framework-v2.pdf', size: '1.2 MB', type: 'pdf' }],
    unread: false,
    replies: 1,
    acknowledged: true,
  },
];

export const DEAL_ROOMS = [
  { id: 'dr-1', name: 'Solano Wind Farm', dealId: 'deal-8', participants: 12, lastActivity: '2025-12-18T14:32:00Z', sector: 'Renewable Energy', stage: 'Execution' },
  { id: 'dr-2', name: 'Nordic Fibre Network Phase II', dealId: 'deal-5', participants: 8, lastActivity: '2025-12-18T11:15:00Z', sector: 'Digital Infrastructure', stage: 'Due Diligence' },
  { id: 'dr-3', name: 'Elbe Biomass Plant', dealId: 'deal-3', participants: 9, lastActivity: '2025-12-17T16:45:00Z', sector: 'Renewable Energy', stage: 'Screening' },
  { id: 'dr-4', name: 'Lisbon Metro Extension', dealId: 'deal-4', participants: 7, lastActivity: '2025-12-15T14:20:00Z', sector: 'Transport', stage: 'Screening' },
];

export const SHARED_DOCUMENTS = [
  { id: 'doc-1', name: 'Technical Due Diligence Report v2.1.pdf', sharedBy: 'Sarah Chen', sharedDate: '2025-12-18T10:00:00Z', size: '4.2 MB', type: 'pdf', version: 'v2.1', category: 'Technical' },
  { id: 'doc-2', name: 'Financial Model v3.0.xlsx', sharedBy: 'Oliver Hartley', sharedDate: '2025-12-17T15:30:00Z', size: '2.8 MB', type: 'xlsx', version: 'v3.0', category: 'Financial' },
  { id: 'doc-3', name: 'Environmental Impact Assessment.pdf', sharedBy: 'Sarah Chen', sharedDate: '2025-12-15T09:00:00Z', size: '6.1 MB', type: 'pdf', version: 'v1.0', category: 'ESG' },
];

export const DATA_ROOM_DOCS = [
  { id: 'dr-doc-1', name: 'Technical Due Diligence Report v2.1.pdf', category: 'Technical', version: 'v2.1', accessLevel: 'Confidential', size: '4.2 MB', type: 'pdf' },
  { id: 'dr-doc-2', name: 'Financial Model v3.0.xlsx', category: 'Financial', version: 'v3.0', accessLevel: 'Restricted', size: '2.8 MB', type: 'xlsx' },
  { id: 'dr-doc-3', name: 'Environmental Impact Assessment.pdf', category: 'ESG', version: 'v1.0', accessLevel: 'Internal', size: '6.1 MB', type: 'pdf' },
  { id: 'dr-doc-4', name: 'Legal Structure Overview.docx', category: 'Legal', version: 'v2.0', accessLevel: 'Restricted', size: '890 KB', type: 'docx' },
  { id: 'dr-doc-5', name: 'Grid Connection Agreement.pdf', category: 'Technical', version: 'v1.2', accessLevel: 'Confidential', size: '1.4 MB', type: 'pdf' },
  { id: 'dr-doc-6', name: 'Insurance Certificate 2025.pdf', category: 'Legal', version: 'v1.0', accessLevel: 'Internal', size: '320 KB', type: 'pdf' },
];

export const MESSAGES = [
  {
    id: 'msg-1',
    threadId: 'thread-1',
    senderId: 'user-2',
    content: 'Good morning everyone. I\'ve uploaded the updated Technical Due Diligence Report (v2.1) which incorporates the revised wind capacity figures from the Solano site survey conducted last week. The key change is an upward revision of the P50 generation estimate from 847 GWh/year to 912 GWh/year — a 7.7% improvement.',
    timestamp: '2025-12-18T09:15:00Z',
    edited: false,
    reactions: { '👍': 3, '✅': 2 },
    replyCount: 1,
    attachment: { id: 'doc-1', name: 'Technical Due Diligence Report v2.1.pdf', size: '4.2 MB', type: 'pdf', version: 'v2.1' },
    quotedReply: null,
  },
  {
    id: 'msg-2',
    threadId: 'thread-1',
    senderId: 'user-4',
    content: 'Thank you Sarah. This is a meaningful improvement. Does the revised P50 figure account for the seasonal wind variability across the full 25-year asset life? I want to ensure the financial model reflects the correct capacity factor.',
    timestamp: '2025-12-18T09:42:00Z',
    edited: false,
    reactions: { '🔍': 1 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
  {
    id: 'msg-3',
    threadId: 'thread-1',
    senderId: 'user-5',
    content: 'I\'ve updated the financial model to reflect the revised generation figures. The IRR improves from 11.8% to 12.4% on an unlevered basis. I\'ll share the updated model now.',
    timestamp: '2025-12-18T10:05:00Z',
    edited: false,
    reactions: { '👍': 4, '✅': 3 },
    replyCount: 0,
    attachment: { id: 'doc-2', name: 'Financial Model v4.2.xlsx', size: '2.8 MB', type: 'xlsx', version: 'v4.2' },
    quotedReply: null,
  },
  {
    id: 'msg-4',
    threadId: 'thread-1',
    senderId: 'user-1',
    content: 'Excellent progress. The IRR improvement is material. @Sarah Chen — can you confirm whether the revised capacity figures have been reviewed by the independent technical advisor, or is this based solely on the internal survey?',
    timestamp: '2025-12-18T10:28:00Z',
    edited: false,
    reactions: {},
    replyCount: 0,
    attachment: null,
    quotedReply: null,
    mentions: ['user-2'],
  },
  {
    id: 'msg-5',
    threadId: 'thread-1',
    senderId: 'user-2',
    content: 'Good question, Alex. The revised figures are based on the internal survey but we have engaged Arup as independent technical advisor. Their review is expected by 20 December. We will not proceed to IC until their sign-off is received.',
    timestamp: '2025-12-18T10:55:00Z',
    edited: false,
    reactions: { '✅': 2 },
    replyCount: 0,
    attachment: null,
    quotedReply: { msgId: 'msg-4', senderName: 'Alex Morgan', preview: 'can you confirm whether the revised capacity figures have been reviewed by the independent technical advisor' },
  },
  {
    id: 'msg-6',
    threadId: 'thread-1',
    senderId: 'user-3',
    content: 'For the record: IC is scheduled for 8 January 2026. All materials must be submitted to the IC secretary by 2 January. Please ensure the final TDD, financial model, and legal structure overview are in the Data Room by that date.',
    timestamp: '2025-12-18T11:10:00Z',
    edited: false,
    reactions: { '✅': 5 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
    dealRef: { name: 'Solano Wind Farm', stage: 'Execution', sector: 'Renewable Energy', dealId: 'deal-8' },
  },
  {
    id: 'msg-7',
    threadId: 'thread-1',
    senderId: 'user-7',
    content: 'I\'ve reviewed the environmental impact assessment. The landscape and ecology section is comprehensive. One concern: the cumulative impact assessment does not reference the proposed Iberian Battery Storage Complex. This should be addressed before IC.',
    timestamp: '2025-12-18T11:45:00Z',
    edited: false,
    reactions: { '🔍': 2 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
  {
    id: 'msg-8',
    threadId: 'thread-1',
    senderId: 'user-2',
    content: 'Noted, Ravi. I\'ll flag this to the environmental consultant and request an addendum. We should have this resolved within 48 hours.',
    timestamp: '2025-12-18T12:02:00Z',
    edited: true,
    reactions: { '👍': 2 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
  {
    id: 'msg-9',
    threadId: 'thread-1',
    senderId: 'user-4',
    content: 'On the financing side — has the senior debt term sheet from Santander Infrastructure Finance been finalised? The last version I saw had a 1.25x DSCR covenant which seems tight given the P50 variability.',
    timestamp: '2025-12-18T12:30:00Z',
    edited: false,
    reactions: {},
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
  {
    id: 'msg-10',
    threadId: 'thread-1',
    senderId: 'user-5',
    content: 'The DSCR covenant has been renegotiated to 1.20x with a cash sweep mechanism above 1.35x. The revised term sheet is with legal for final review. We expect execution by 19 December.',
    timestamp: '2025-12-18T13:15:00Z',
    edited: false,
    reactions: { '✅': 3, '👍': 1 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
  {
    id: 'msg-11',
    threadId: 'thread-1',
    senderId: 'user-1',
    content: 'Good progress all round. To summarise where we stand: TDD v2.1 uploaded ✅, Financial model updated to 12.4% IRR ✅, Arup ITA review pending (due 20 Dec), EIA addendum requested, debt term sheet under legal review. I\'ll circulate a formal IC readiness checklist by end of day.',
    timestamp: '2025-12-18T14:00:00Z',
    edited: false,
    reactions: { '✅': 4, '👍': 3 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
  {
    id: 'msg-12',
    threadId: 'thread-1',
    senderId: 'user-2',
    content: 'Perfect summary, Alex. One final point — the grid connection agreement with REE (Red Eléctrica de España) has been signed. I\'ll upload the executed copy to the Data Room this afternoon.',
    timestamp: '2025-12-18T14:32:00Z',
    edited: false,
    reactions: { '👍': 2 },
    replyCount: 0,
    attachment: null,
    quotedReply: null,
  },
];

export const ALL_DEALS = [
  { id: 'deal-8', name: 'Solano Wind Farm', stage: 'Execution', sector: 'Renewable Energy' },
  { id: 'deal-5', name: 'Nordic Fibre Network Phase II', stage: 'Due Diligence', sector: 'Digital Infrastructure' },
  { id: 'deal-3', name: 'Elbe Biomass Plant', stage: 'Screening', sector: 'Renewable Energy' },
  { id: 'deal-6', name: 'Avon Water Treatment Works', stage: 'Asset Management', sector: 'Utilities' },
  { id: 'deal-4', name: 'Lisbon Metro Extension', stage: 'Screening', sector: 'Transport' },
  { id: 'deal-7', name: 'Tyne Bridge Toll Road', stage: 'IC Review', sector: 'Transport' },
];

export function formatRelativeTime(isoString) {
  const date = new Date(isoString);
  const now = new Date('2025-12-18T15:00:00Z');
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  return date?.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export function formatMessageTime(isoString) {
  const date = new Date(isoString);
  return date?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export function getParticipant(id) {
  return PARTICIPANTS?.find(p => p?.id === id) || { id, name: 'Unknown', initials: '?', role: 'investor', color: '#666' };
}

export function getDateLabel(isoString) {
  const date = new Date(isoString);
  const today = new Date('2025-12-18');
  const yesterday = new Date('2025-12-17');
  if (date?.toDateString() === today?.toDateString()) return 'Today';
  if (date?.toDateString() === yesterday?.toDateString()) return 'Yesterday';
  return date?.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}
